import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../css/ServiceCompanyCreatePassword.css';

function ServiceCompanyCreatePassword() {
    const navigate = useNavigate();
    const [createPasswordHash, setCreatePasswordHash] = useState("");
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({
        password: '',
        confirmPassword: ''
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const createPasswordHashFromUrl = queryParams.get('cp') || "";
        setCreatePasswordHash(createPasswordHashFromUrl);
    }, []);

    const validatePassword = (password) => {
        if (password.length < 8) {
            return 'Password must be at least 8 characters long';
        }
        return '';
    };

    const validateConfirmPassword = (password, confirmPassword) => {
        if (password !== confirmPassword) {
            return 'Passwords do not match';
        }
        return '';
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === 'password') {
            setErrors(prev => ({
                ...prev,
                password: validatePassword(value),
                confirmPassword: validateConfirmPassword(value, formData.confirmPassword)
            }));
        } else if (name === 'confirmPassword') {
            setErrors(prev => ({
                ...prev,
                confirmPassword: validateConfirmPassword(formData.password, value)
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const passwordError = validatePassword(formData.password);
        const confirmPasswordError = validateConfirmPassword(
            formData.password,
            formData.confirmPassword
        );

        if (passwordError || confirmPasswordError) {
            setErrors({
                password: passwordError,
                confirmPassword: confirmPasswordError
            });
            return;
        }

        try {
            const data = {
                ...formData,
                createPasswordHash
            };
            const response = await axios.post('/api/service_provider_create_password', data);

            if (response.status !== 200) {
                throw new Error('Failed to create password');
            }

            if (response.data.next_page === 'trades') {
                navigate('/service-company-trades')
            } else if (response.data.next_page === 'details') {
                navigate('/service-company-details')
            } else {
                navigate('/service-company/' + response.data.link_hash)
            }
        } catch (error) {
            setErrors(prev => ({
                ...prev,
                submit: 'Failed to create password. Please try again.'
            }));
        }
    };

    const isFormValid = !errors.password &&
        !errors.confirmPassword &&
        formData.password &&
        formData.confirmPassword;

    return (
        <div className="serviceCompanyCreatePasswordContainer">
            <div className="serviceCompanyCreatePasswordTitle">
                Thank You For Joining Our Exclusive Directory!
            </div>

            <div className="serviceCompanyCreatePasswordFormWrapper">
                <h2 className="serviceCompanyCreatePasswordFormTitle">Create Your Account Password</h2>

                <form onSubmit={handleSubmit} className="serviceCompanyCreatePasswordFormContainer">
                    <div className="serviceCompanyCreatePasswordPasswordRequirement">
                        Your password must be at least 8 characters:
                    </div>

                    <div className="serviceCompanyCreatePasswordInputGroup">
                        <label htmlFor="password" className="serviceCompanyCreatePasswordInputLabel">
                            Create a Password <span className="serviceCompanyCreatePasswordAsterisk">*</span>
                        </label>
                        <div className="serviceCompanyCreatePasswordInputWrapper">
                            <input
                                type="password"
                                id="password"
                                name="password"
                                className={`serviceCompanyCreatePasswordInput ${errors.password ? 'serviceCompanyCreatePasswordHasError' : ''}`}
                                value={formData.password}
                                onChange={handleInputChange}
                                placeholder="Enter Password"
                                required
                                aria-required="true"
                                aria-invalid={!!errors.password}
                                aria-describedby={errors.password ? "password-error" : undefined}
                            />
                            {errors.password && (
                                <span id="password-error" className="serviceCompanyCreatePasswordError">
                    {errors.password}
                  </span>
                            )}
                        </div>
                    </div>

                    <div className="serviceCompanyCreatePasswordInputGroup">
                        <label htmlFor="confirmPassword" className="serviceCompanyCreatePasswordInputLabel">
                            Confirm Password <span className="serviceCompanyCreatePasswordAsterisk">*</span>
                        </label>
                        <div className="serviceCompanyCreatePasswordInputWrapper">
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                className={`serviceCompanyCreatePasswordInput ${errors.confirmPassword ? 'serviceCompanyCreatePasswordHasError' : ''}`}
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                placeholder="Confirm Password"
                                required
                                aria-required="true"
                                aria-invalid={!!errors.confirmPassword}
                                aria-describedby={errors.confirmPassword ? "confirm-password-error" : undefined}
                            />
                            {errors.confirmPassword && (
                                <span id="confirm-password-error" className="serviceCompanyCreatePasswordError">
                    {errors.confirmPassword}
                  </span>
                            )}
                        </div>
                    </div>

                    <div className="serviceCompanyCreatePasswordRequiredField">
                        <span className="serviceCompanyCreatePasswordAsterisk">*</span> Required
                    </div>

                    {errors.submit && (
                        <div className="serviceCompanyCreatePasswordError" role="alert">
                            {errors.submit}
                        </div>
                    )}

                    <button
                        type="submit"
                        className={`serviceCompanyCreatePasswordSubmitButton ${isFormValid ? 'active' : ''}`}
                        disabled={!isFormValid}
                    >
                        Save and Continue
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ServiceCompanyCreatePassword;
